import React, {FC} from "react";
import {useLocale} from "@/contexts/localeContext.tsx";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import {useFormikContext} from "formik";

interface summaryProps {
    onBack: () => void;
}

const Summary: FC<summaryProps> = ({onBack}) => {
    const {translate} = useLocale();
    const {values} = useFormikContext<any>();

    return <div className="pt-3 pr-3 h-full relative">
        <span className="text-lg font-bold">{translate.byKey(TranslationKeys.selectedIdpGroup)}</span>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.groupName)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.groupDescription)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.idpGroupName}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.idpGroupDescription}</span>
            </div>
        </div>
        <>
            <span className="pt-4 text-lg font-bold">{translate.byKey(TranslationKeys.selectedPermission)}</span>
            <div className="flex flex-row">
                <div className="flex flex-col">
                    <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.permissionName)}:</span>
                </div>
                <div className="flex flex-col">
                    <span className="pt-1 text-sm text-black pl-2">{values.profileName}</span>
                </div>
            </div>
        </>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={(e) => onBack()}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={'submit'}>
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>
}

export default Summary;
